export default __webpack_public_path__ + "static/media/Prozesssimple.61aebd93.png";